class MultiStepForm {
  static async init () {
    const navListItems = $('.setup-panel .btn')
    const allWells = $('.setup-content')
    const allNextBtn = $('.nextBtn')
    const allPrevBtn = $('.prevBtn')
    const formGroup = $('.form-group')

    allWells.hide()

    function updatePassedSteps (currentStepId) {
      let passed = true

      navListItems.each(function () {
        const stepId = $(this).attr('href').replace('#', '')

        if (stepId === currentStepId) {
          passed = false
          $(this).removeClass('passed')
          return
        }

        if (passed) {
          $(this).addClass('passed')
        } else {
          $(this).removeClass('passed')
        }
      })
    }

    navListItems.click(function (e) {
      e.preventDefault()
      const $target = $($(this).attr('href'))
      const $item = $(this)

      if (!$item.hasClass('disabled')) {
        navListItems.removeClass('btn-primary').addClass('btn-light')
        $item.addClass('btn-primary').removeClass('btn-light')

        allWells.hide()
        $target.show()
        $target.find('input:eq(0)').focus()

        updatePassedSteps($target.attr('id'))
      }
    })

    allNextBtn.click(function () {
      let curStep = $(this).closest('.setup-content')
      let curStepBtn = curStep.attr('id')
      let nextStepWizard = $('.setup-panel div a[href="#' + curStepBtn + '"]').parent().next().children('a')
      let curInputs = curStep.find("input[type='text'],input[type='url'],input[type='checkbox'],input[type='radio'],select")
      let isValid = true

      formGroup.removeClass('has-error')

      for (let i = 0; i < curInputs.length; i++) {
        if (!curInputs[i].validity.valid) {
          isValid = false
          $(curInputs[i]).closest(formGroup).addClass('has-error')
        }
      }

      if (isValid) {
        nextStepWizard.removeAttr('disabled').trigger('click')
      }
    })

    allPrevBtn.click(function () {
      let curStep = $(this).closest('.setup-content')
      let curStepBtn = curStep.attr('id')
      let prevStepWizard = $('.setup-panel div a[href="#' + curStepBtn + '"]').parent().prev().children('a')

      if (prevStepWizard.length) {
        prevStepWizard.trigger('click')
      }
    })

    $('.setup-panel a.btn-primary').trigger('click')
  }
}

export default MultiStepForm
